.rateAnswer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--vkui--color_background_tertiary);
  border-radius: 12px;
  padding: 8px;
}

.emptyIcons svg {
  display: inline-block;
}

.filledIcons svg {
  display: inline-block;
  fill: var(--rating-star-fill-color);
}
